import { useEffect } from "react"
import { AdminDashboardClient } from "@/domain/admin/client/AdminDashboardClient"
import {
  AdminDashboardStore,
  makeInitAdminDashboardState,
} from "@/domain/admin/store/AdminDashboardStore"

export function useAdminDashboard() {
  function useAdminDashboardState() {
    return AdminDashboardStore.useStore()
  }

  async function fetchSummary() {
    try {
      const summary = await AdminDashboardClient.getSummary()
      AdminDashboardStore.set("summary", summary)
      AdminDashboardStore.set("errorMessage", "")
    } catch (error) {
      AdminDashboardStore.set("summary", null)
      AdminDashboardStore.set(
        "errorMessage",
        error instanceof Error
          ? error.message
          : "대시보드를 불러오지 못했습니다.",
      )
    } finally {
      AdminDashboardStore.set("isLoaded", true)
    }
  }

  useEffect(() => {
    AdminDashboardStore.store.setState(makeInitAdminDashboardState())
    void fetchSummary()

    return () => {
      AdminDashboardStore.store.setState(makeInitAdminDashboardState())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { useAdminDashboardState }
}
